// extracted by mini-css-extract-plugin
export default {"MoreButton":"MoreTableButton_MoreButton__BFouS"};